'use client';

import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

interface KitSearchBarProps {
  onSearch?: (query: string) => void;
}

export default function KitSearchBar({ onSearch }: KitSearchBarProps) {
  const [value, setValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onSearch?.(e.target.value);
  };

  const handleClear = () => {
    setValue('');
    onSearch?.('');
  };

  return (
    <div className="relative">
      <Search
        size={15}
        className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
        style={{ color: '#94a3b8' }}
      />
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Search by Kit Name, CC Name, CC No or Serial..."
        className="w-full pl-9 pr-8 py-2.5 text-sm rounded-lg outline-none transition-all"
        style={{
          background: '#ffffff',
          border: '1.5px solid #e2e8f0',
          color: '#1a2332',
        }}
        onFocus={e => { e.currentTarget.style.borderColor = '#0369a1'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(3,105,161,0.1)'; }}
        onBlur={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = 'none'; }}
      />
      {value && (
        <button
          onClick={handleClear}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 transition-colors"
          style={{ color: '#94a3b8' }}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}